import {configureStore} from '@reduxjs/toolkit'
import {persistStore} from 'redux-persist'
import createSagaMiddleware from 'redux-saga'
import {reduxBatch} from '@manaflair/redux-batch'

// import { rootReducer, rootSaga } from "./rootReducer";
import {rootReducer} from './rootReducer'

const sagaMiddleware = createSagaMiddleware()
const middleware = (getDefaultMiddleware: any) =>
  getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
    thunk: true,
  }).concat(sagaMiddleware)

const store = configureStore({
  reducer: rootReducer,
  middleware: middleware,
  devTools: process.env.NODE_ENV !== 'production',
  enhancers: [reduxBatch],
})

export const persistor = persistStore(store)

// sagaMiddleware.run(rootSaga);

export default store
